import script from "./AddEntityInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEntityInput.vue?vue&type=script&setup=true&lang=js"

import "./AddEntityInput.vue?vue&type=style&index=0&id=5af0403c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af0403c"]])

export default __exports__